import { useTranslation } from "react-i18next";
import { Circle, Diamond, RectangleHorizontal, Square } from "lucide-react";

import InfoCard from "@/components_v2/Card/InfoCard";
import {
  GainItem,
  WhatYouGainProps,
} from "@/features/certifications/details/components/types";

import "./styles.css";

const ICON_SIZE = 16;
const ICON_BACKGROUNDS = ["var(--primary-100)", "var(--primary-200)"];
const ICON_COLOR = "var(--primary-1000)";

const GAINS: GainItem[] = [
  { key: "definition", icon: <Circle size={ICON_SIZE} /> },
  { key: "teaching", icon: <Diamond size={ICON_SIZE} fill="currentColor" /> },
  { key: "practice", icon: <Square size={ICON_SIZE} /> },
  { key: "cohort", icon: <Circle size={ICON_SIZE} fill="currentColor" /> },
  { key: "credential", icon: <RectangleHorizontal size={ICON_SIZE} /> },
];

const WhatYouGain = ({ contentKey }: WhatYouGainProps) => {
  const { t } = useTranslation();

  return (
    <section className="flex flex-col gap-400">
      <h2 className="certification-section-title header-l-medium">
        {t("certification.details.gainsTitle")}
      </h2>

      <div className="certification-gains flex flex-wrap gap-300">
        {GAINS.map((gain, index) => (
          <InfoCard
            key={gain.key}
            icon={gain.icon}
            title={t(`${contentKey}.gains.${gain.key}.title`)}
            description={t(`${contentKey}.gains.${gain.key}.description`)}
            iconBackgroundColor={
              ICON_BACKGROUNDS[index % ICON_BACKGROUNDS.length]
            }
            iconColor={ICON_COLOR}
          />
        ))}
      </div>
    </section>
  );
};

export default WhatYouGain;
